import { environment } from '@env/environment';
import { Settings } from '@makiwin/ngx-drupal8-rest';

export const drupal8Settings: Settings = {
  protocol: 'https',
  // host: 'stage.api.ikointl.com',
  host: environment.serverUrl,
  requestTimeout: 2000000,
};
